import { AfterContentInit, AfterViewInit, Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { ProXSignService } from '../../../../services/pro-xsign-integration.service';
import { DialogType } from '../../../../shared/components/sem-dynamic/sem-dynamic.component';
import { SemConfirmDialogComponent } from '../../dialogs/sem-confirm-dialog/sem-confirm-dialog.component';
import { PxsBaseComponent } from '../pxs-base/pxs-base.component';

@Component({
  selector: 'pxs-check-version',
  templateUrl: './pxs-check-version.component.html',
  styleUrls: ['./pxs-check-version.component.css'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: PxsCheckVersionComponent, multi: true }
  ]
})
export class PxsCheckVersionComponent extends PxsBaseComponent implements OnInit, AfterViewInit, AfterContentInit, OnDestroy {

  versionNumber: string = "";
  versionText: string = "";
  selectedSubject: string = "";
  error: boolean = false;
  public proXSignLib: any;
  certLoad: boolean = false;

  @Input() certProp: any = null;

  // Inject ProXSignService only in this component
  public proXSignService = inject(ProXSignService);
  s2: Subscription;

  super() { }

  ngOnInit(): void {
    super.ngOnInit();

    this.certLoad = true;
    this.error = false;
    this.proXSignService.loadScript().then(() => {

      if (this.proXSignService.isLibraryLoaded()) {
        this.proXSignLib = this.proXSignService.getLibrary();

        if (this.proXSignLib) {
          //console.log("proXSign initialized:", this.proXSignLib);

          // Initialize and wait for the callback before selecting certificate
          this.proXSignLib.initialize(() => {
            //console.log("ProXSign successfully initialized.");

            this.versionNumber = this.proXSignLib.version;
            this.versionText = "Podpisna komponenta proXSign je pripravljena";


            this.proXSignLib.updateLicense({ fileURL: this.proXSignService.licenceUrl, forceUpdate: true, fileContent: this.proXSignService.licenceContent }, this.callbackLicense, this.callbackLicenceError);


            this.error = false;
            this.certLoad = false;

            // Now safely call selectCertificate after initialization
            var cert = this.dfms.getValue(this.model, this.certProp);

            if (cert && typeof cert != "undefined" && cert.length > 0) {
              var jsCert = JSON.parse(cert);
              this.selectedSubject = jsCert.subject;
            } else {
              this.selectCert();
            }
          }, this.callbackError);
        } else {
          this.certLoad = false;
          console.error("proXSign library is still undefined after loading.");
        }
      } else {
        this.certLoad = false;
      }
    }).catch(error => {
      console.error("Failed to load proXSign:", error);
    });
  }

  selectCert() {
    const prop = this.proXSignLib.XMLProperties("bytes", [""]);
    this.proXSignLib.selectCertificate(prop, this.callbackCert, this.callbackError);
  }

  callbackError = (jqXHR, textStatus, errorThrown) => {
    console.error("ProXSign Error:", jqXHR, textStatus, errorThrown);
    this.error = true;
    this.certLoad = false;
  }

  callbackCert = (data, textStatus) => {
    if (data.error === 1) { // SIGN OK
      const certInfo = data.certificates[0];
      const certDetails = `
        ******* Certificate *******
        Status: ${certInfo.status}
        SerialNumber: ${certInfo.serialNumber}
        Hash: ${certInfo.certHash}
        Hash base64: ${certInfo.certHashB64}
        Subject: ${certInfo.subject}
        SubjectDN: ${certInfo.subjectDN}
        Issuer: ${certInfo.issuer}
      `;

      //console.log("Selected Certificate:", certDetails);
      this.selectedSubject = certInfo.subject;

      if (this.certProp && this.certProp.length > 0) {
        this.dfms.assign(this.model, this.certProp, JSON.stringify(data.certificates[0]), true);
      }
    }
    else if (data.error == -3) {
      //this.showError("Prosimo, izberite veljavno digitalno potrdilo. Brez potrdila oddaja vloge ni mogoča.", data, false)
      this.selectCert();
    }
    else {
      this.showError("Prišlo je do napake pri izbiri potrdila, prosimo poskusite znova.", data, false)
    }
  }

  showError(text: string, data, showErrorCode) {

    if (showErrorCode) {
      text = text + " Koda napake: " + data.error;
    }

    const dialogRef = this.dialog.open(SemConfirmDialogComponent, { data: { cssclass: "conf-error", type: DialogType.NotificationSuccess, text: text } });

    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 1);

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  ngAfterContentInit(): void {
  }

  callbackLicense = (data, textStatus) => {

    var s;
    if (data.error == 1) {
    }   // SIGN ERROR
    else {
      s = "Error code:  " + data.error; //Error codes are described in xErrors.txt file
      s += "\r\nError message:  " + data.errorMessage;
      console.log(s);
    }

  }

  callbackLicenceError = (jqXHR, textStatus, errorThrown) => {

    var s = "Error :  " + JSON.stringify(jqXHR); // General error in ajax call
    console.log("Napaka : proXSign komponenta se ne odziva");
    console.log(s);
  }

  ngOnDestroy(): void {
  }
}
